import "../styles/styles.css";

export default function Loader() {
    return (
        <div className="loader--container">
            <div className="loader"></div>
        </div>
    );
}